import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Toast, ToastContainer } from 'react-bootstrap';
import axios from "axios";
import { hashPassword } from "./Functions/LoginFunctions";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { API_ENDPOINTS } from '../config';
import CryptoJS from 'crypto-js';

function Register() {
  const [formData, setFormData] = useState({
    username: '',
    firstname: '',
    lastname: '',
    email: '',
    password: ''
  });

  const [toastState, SetToastState] = useState(false);
  const [toastMessage, SetToastMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [confirmPass, setconfirmPass] = useState("");
  const navigate = useNavigate();


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePasswordChange = (e) => {
    setconfirmPass(e.target.value);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("1. A handleSubmit elindult. Form adatok:", formData);
    if (formData.password !== confirmPass) {
      SetToastMessage("Passwords do not match.");
      handleShowToast();
      return;
    }

    setIsLoading(true);

    try {
      const hashedPassword = await hashPassword(formData.password);

      const requestBody = {
        username: formData.username,
        firstname: formData.firstname,
        lastname: formData.lastname,
        email: formData.email,
        password: hashedPassword
      };
      console.log(hashedPassword)
      const response = await axios.post(API_ENDPOINTS.REGISTER, requestBody, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
        console.log("Kattintás!");


      if (response.status == 200) {
        navigate('/login');
      } else {
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
     

    }
  };

  const handleShowToast = () => {
    SetToastState(true);
  };

  const handleCloseToast = () => {
    SetToastState(false);
  };

  const Toastbtn = () => {

    return (
      <div className="">

        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            show={toastState}
            onClose={handleCloseToast}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto">Notification</strong>
              <small>Just now</small>
            </Toast.Header>
            <Toast.Body>
              {toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    )
  }

  return (
    <Container fluid className="bg-chess min-vh-100 d-flex align-items-center">
      <Toastbtn />
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={4}>
            <Card className="shadow bg-dark">
              <Card.Header className="d-flex align-items-center justify-content-center position-relative">
                <Button
                  variant="link"
                  className="text-white p-0 position-absolute"
                  style={{ left: '1rem' }}
                  onClick={() => navigate("/login")}
                >
                  <i className="bi bi-arrow-left"></i>
                </Button>

                <Card.Title className="text-white mb-0 text-center">Registration</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={handleSubmit} noValidate>
                  <Form.Group className="mb-3" controlId="formUsername">
                    <Form.Label className="text-white d-block text-start w-100">Username</Form.Label>
                    <Form.Control
                      type="text"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      placeholder="Username" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formFirstname">
                    <Form.Label className="text-white d-block text-start w-100">First name</Form.Label>
                    <Form.Control
                      type="text"
                      name="firstname"
                      value={formData.firstname}
                      onChange={handleChange}
                      placeholder="First name" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formLastname">
                    <Form.Label className="text-white d-block text-start w-100">Last name</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastname"
                      value={formData.lastname}
                      onChange={handleChange}
                      placeholder="Last name" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label className="text-white d-block text-start w-100">Email address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="email@example.com" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label className="text-white d-block text-start w-100">Password</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Password" />
                  </Form.Group>


                  <Form.Group className="mb-3" controlId="confirmPassword">
                    <Form.Label className="text-white d-block text-start w-100">Confirm Password</Form.Label>
                    <Form.Control
                      type="password"
                      name="confirmPassword"
                      value={confirmPass}
                      onChange={handlePasswordChange}
                      placeholder="Password" />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="bg-light-green w-100 txt-dark-green"
                    size="lg"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Loading...' : 'Register'}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Register;